import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { HeartHandshake } from "lucide-react";

export default function PaymentCancel() {
    return (
        <main data-testid="payment-cancel-page" className="flex min-h-screen items-center justify-center bg-cream px-6 text-navy">
            <motion.div
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1] }}
                className="w-full max-w-lg rounded-3xl border border-warmgray bg-ivory p-10 text-center shadow-xl shadow-navy/5"
            >
                <div className="flex justify-center">
                    <HeartHandshake size={36} className="text-lavender" />
                </div>
                <h1 className="mt-6 font-display text-2xl md:text-3xl">No charge was made.</h1>
                <p className="mt-4 text-sm leading-relaxed text-navy">
                    You cancelled before completing checkout. Your support means the world — the door is always open when you’re ready.
                </p>
                <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
                    <Link
                        data-testid="retry-support-link"
                        to="/#support"
                        className="btn-gradient rounded-full px-8 py-3.5 text-sm font-medium text-white transition-transform duration-300 hover:-translate-y-0.5"
                    >
                        Try Again
                    </Link>
                    <Link
                        data-testid="cancel-home-link"
                        to="/"
                        className="rounded-full border border-navy/20 px-8 py-3.5 text-sm font-medium text-navy transition-colors duration-300 hover:border-navy/40"
                    >
                        Back Home
                    </Link>
                </div>
            </motion.div>
        </main>
    );
}
